import day from "dayjs";

const maybeJoin = (label, values) => {
  if (!values || values.length === 0) return "";
  return `${label}: ${values.join(", ")}`;
};

export const calendarEventToActivityDefaults = () => (event) => {
  const performedOn = event?.end ? day.unix(event.end) : day();

  const lines = [
    event?.subject ? `Subject: ${event.subject}` : "",
    event?.organizer?.length ? maybeJoin("Organizer", event.organizer) : "",
    event?.attendees?.length ? maybeJoin("Attendees", event.attendees) : "",
    event?.location ? `Location: ${event.location}` : "",
    event?.webLink ? `Link: ${event.webLink}` : "",
    event?.bodyPreview ? `Notes: ${event.bodyPreview}` : "",
  ].filter(Boolean);

  return {
    integrations: event?.id
      ? [
          {
            type: "microsoft_graph_event",
            payload: {
              eventId: event.id,
              userId: event?.user?._id || null,
            },
          },
        ]
      : [],
    performedOn,
    summary: lines.join("\n"),
  };
};
